import { useLocation } from 'react-router-dom';
import { RouteConfig } from '@/shared/lib';
import { isActive } from '../utils';

export const useIsActive = (route: RouteConfig) => {
  const { pathname } = useLocation();

  return { isActive: isActive(route, pathname) };
};
